/* Stament type code list */
export const INFUSION = 'INFUSION'
export const RESERVE = 'RESERVE'
export const REFUND = 'REFUND'
export const REVERSAL = 'REVERSAL'
export const CHARGEBACK = 'CHARGEBACK'
export const COMISSION = 'COMISSION'
export const REVERSAL_OVERINFUSION = 'REVERSAL_OVERINFUSION'
